var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link sidebartoggler d-none d-md-block text-muted waves-effect waves-dark",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toggleNavbar}},[_c('i',{staticClass:"ti-menu"})])
}
var staticRenderFns = []

export { render, staticRenderFns }